const home = {
  title: "Командный центр GAM",
  description: "Внутренняя панель управления проектами для G.A.M",
  openDashboard: "Открыть дашборд",
  workspaceName: "G.A.M — Командный центр",
  workspaceLabel: "Рабочая область",
  devDashboard: "Дашборд разработки",
  devDashboardDesc: "Проекты, редактор, карта историй, виджеты",
  clientManagement: "Управление системами клиентов",
  clientManagementDesc: "Клиентские порталы, отчёты, CRM",
  adminDevLog: "Журнал разработки и админ",
  adminDevLogDesc: "Статус системы, компоненты, отслеживание версий",
  comingSoon: "Скоро",
  active: "Активен",
} as const;
export default home;
